import api from '../..'
import { IFolderModel, IFolderSortSettings } from 'models/folder.model'

const sortConfigurationFolder = (
  id: number,
  sortSettings: IFolderSortSettings,
  orderCourses?: string[]
) => {
  return api
    .patch<{ data: { attributes: IFolderModel } }>(
      `/administration/folders/${id}/sort_configuration`,
      {
        sortSettings,
        orderCourses,
      }
    )
    .then(({ data }) => data.data.attributes)
}

export default sortConfigurationFolder
